module.exports = __webpack_public_path__ + "ae1c9a5cc5ea4cfbae9eb8314dd6a608.svg";